import TimeZoneSelector from '@/components/TimeZoneSelect/time-zone-select.component';
import { ICalendar } from '@/types/ICalendar';
import {
	Box,
	Button,
	FormControl,
	FormLabel,
	Input,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
} from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { t } from 'i18next';
import { useEditCalendarController } from './edit-calendar-modal.controller';

interface IProps {
	onClose: () => void;
	calendar: ICalendar;
	isOpen: boolean;
}

export function EditCalendarModal(props: IProps) {
	const { form, options, selectedOption, handleSubmit } = useEditCalendarController(props);
	return (
		<Modal isOpen={props.isOpen} onClose={props.onClose} size="xl">
			<ModalOverlay />

			<ModalContent>
				<ModalHeader>{t('Edit calendar')}</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Box id="edit-calendar-form" as="form" onSubmit={handleSubmit}>
						<FormControl>
							<FormLabel>{t('Name')}</FormLabel>
							<Input {...form.register('name')} type="text" />
						</FormControl>

						<FormControl mt={4}>
							<FormLabel>{t('Description')}</FormLabel>
							<Input {...form.register('description')} type="text" />
						</FormControl>

						<FormControl mt={4}>
							<FormLabel>{t('TimeZone')}</FormLabel>
							<TimeZoneSelector
								value={form.watch('defaultTimeZone') || ''}
								onChange={(v) => {
									form.setValue('defaultTimeZone', v);
								}}
							/>
						</FormControl>

						<FormControl mt={4}>
							<FormLabel>{t('Owner')}</FormLabel>
							<Select
								value={selectedOption}
								getOptionLabel={(org) => org.name}
								getOptionValue={(org) => org.id}
								options={options}
								onChange={(v) => {
									if (!v) {
										return;
									}

									form.setValue('owner', v);
								}}
							/>
						</FormControl>
					</Box>
				</ModalBody>
				<ModalFooter>
					<Button isLoading={form.formState.isSubmitting} type="submit" form="edit-calendar-form" colorScheme="primary">
						{t('Save')}
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
}
